import React from 'react'

export const MainImage: React.ReactNode = (
  <svg width="601" height="653" viewBox="0 0 601 653" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M34.4531 57.624H557.544V581.292H34.4531V57.624Z" fill="#EAEEF5" />
    <path d="M34 81.7688L68.1232 57H71.3585L34 84.1173V81.7688Z" fill="#DAE0EB" />
    <path d="M34 116.451V114.103L112.668 57H115.904L34 116.451Z" fill="#DAE0EB" />
    <path d="M34 148.785V146.436L157.213 57H160.449L34 148.785Z" fill="#DAE0EB" />
    <path d="M34 181.12V178.771L201.76 57H204.995L34 181.12Z" fill="#DAE0EB" />
    <path d="M34 213.453V211.105L246.305 57H249.54L34 213.453Z" fill="#DAE0EB" />
    <path d="M34 245.787V243.439L290.85 57H294.086L34 245.787Z" fill="#DAE0EB" />
    <path d="M34 278.121V275.773L335.395 57H338.631L34 278.121Z" fill="#DAE0EB" />
    <path d="M34 310.455V308.106L379.94 57H383.176L34 310.455Z" fill="#DAE0EB" />
    <path d="M34 342.789V340.44L424.486 57H427.721L34 342.789Z" fill="#DAE0EB" />
    <path d="M34 375.122V372.774L469.031 57H472.266L34 375.122Z" fill="#DAE0EB" />
    <path d="M34 407.457V405.109L513.577 57H516.813L34 407.457Z" fill="#DAE0EB" />
    <path d="M34 439.791V437.443L558 57.0888V59.4373L34 439.791Z" fill="#DAE0EB" />
    <path d="M34 472.125V469.776L558 89.4226V91.7711L34 472.125Z" fill="#DAE0EB" />
    <path d="M34 504.459V502.11L558 121.756V124.105L34 504.459Z" fill="#DAE0EB" />
    <path d="M34 536.792V534.444L558 154.09V156.439L34 536.792Z" fill="#DAE0EB" />
    <path d="M34 569.126V566.778L558 186.424V188.773L34 569.126Z" fill="#DAE0EB" />
    <path d="M62.1883 581H58.953L558 218.759V221.107L62.1883 581Z" fill="#DAE0EB" />
    <path d="M106.733 581H103.498L558 251.093V253.441L106.733 581Z" fill="#DAE0EB" />
    <path d="M151.279 581H148.043L558 283.426V285.775L151.279 581Z" fill="#DAE0EB" />
    <path d="M195.824 581H192.588L558 315.76V318.109L195.824 581Z" fill="#DAE0EB" />
    <path d="M240.369 581H237.134L558 348.094V350.442L240.369 581Z" fill="#DAE0EB" />
    <path d="M284.914 581H281.679L558 380.428V382.776L284.914 581Z" fill="#DAE0EB" />
    <path d="M329.459 581H326.224L558 412.762V415.11L329.459 581Z" fill="#DAE0EB" />
    <path d="M374.006 581H370.77L558 445.096V447.445L374.006 581Z" fill="#DAE0EB" />
    <path d="M418.551 581H415.315L558 477.43V479.779L418.551 581Z" fill="#DAE0EB" />
    <path d="M463.096 581H459.861L558 509.764V512.112L463.096 581Z" fill="#DAE0EB" />
    <path d="M507.641 581H504.406L558 542.098V544.446L507.641 581Z" fill="#DAE0EB" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.499871 57.5731C0.499942 56.7447 1.17157 56.0732 2 56.0732L590 56.124C590.828 56.1241 591.5 56.7957 591.5 57.6241C591.5 58.4525 590.828 59.1241 589.999 59.124L1.99974 59.0732C1.17131 59.0732 0.4998 58.4015 0.499871 57.5731Z"
      fill="#C5CEDE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 26.5H16.6378V29.5H0.5V26.5ZM40.5028 26.5H70.2652V29.5H40.5028V26.5ZM93.9212 26.5H123.689V29.5H93.9212V26.5ZM147.385 26.5H177.171V29.5H147.385V26.5ZM200.938 26.5H230.636V29.5H200.938V26.5ZM254.362 26.5H284.1V29.5H254.362V26.5ZM307.842 26.5H337.584V29.5H307.842V26.5ZM361.322 26.5H391.053V29.5H361.322V26.5ZM414.774 26.5H444.525V29.5H414.774V26.5ZM468.282 26.5H498.037V29.5H468.282V26.5ZM521.77 26.5H551.438V29.5H521.77V26.5ZM575.249 26.5H591.501V29.5H575.249V26.5Z"
      fill="#C5CEDE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M557.547 26.5C558.375 26.5 559.047 27.1716 559.047 28V610.916C559.047 611.744 558.375 612.416 557.547 612.416C556.718 612.416 556.047 611.744 556.047 610.916V28C556.047 27.1716 556.718 26.5 557.547 26.5Z"
      fill="#C5CEDE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M591.5 27.4561V43.4375H588.5V27.4561H591.5ZM591.5 66.9829V96.4268H588.5V66.9829H591.5ZM591.5 119.766V149.215H588.5V119.766H591.5ZM591.5 172.593V202.061H588.5V172.593H591.5ZM591.5 225.509V254.889H588.5V225.509H591.5ZM591.5 278.297V307.717H588.5V278.297H591.5ZM591.5 331.141V360.565H588.5V331.141H591.5ZM591.5 383.984V413.398H588.5V383.984H591.5ZM591.5 436.801V466.233H588.5V436.801H591.5ZM591.5 489.672V519.109H588.5V489.672H591.5ZM591.5 542.523V571.874H588.5V542.523H591.5ZM591.5 595.366V611.46H588.5V595.366H591.5Z"
      fill="#C5CEDE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.4531 26.5C35.2816 26.5 35.9531 27.1716 35.9531 28L35.9531 610.916C35.9531 611.744 35.2816 612.416 34.4531 612.416C33.6247 612.416 32.9531 611.744 32.9531 610.916L32.9531 28C32.9531 27.1716 33.6247 26.5 34.4531 26.5Z"
      fill="#C5CEDE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 26.5L3.5 42.5242H0.5L0.5 26.5H3.5ZM3.5 66.1568L3.5 95.6878H0.5L0.5 66.1568H3.5ZM3.5 119.113L3.5 148.649H0.5L0.5 119.113H3.5ZM3.5 172.114L3.5 201.669H0.5L0.5 172.114H3.5ZM3.5 225.204L3.5 254.671H0.5L0.5 225.204H3.5ZM3.5 278.166L3.5 307.673H0.5L0.5 278.166H3.5ZM3.5 331.184L3.5 360.694H0.5L0.5 331.184H3.5ZM3.5 384.201L3.5 413.701H0.5L0.5 384.201H3.5ZM3.5 437.191L3.5 466.71H0.5L0.5 437.191H3.5ZM3.5 490.236L3.5 519.76H0.5L0.5 490.236H3.5ZM3.5 543.261L3.5 572.699H0.5L0.5 543.261H3.5ZM3.5 596.278L3.5 612.416H0.5L0.5 596.278H3.5Z"
      fill="#C5CEDE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.499497 581.299C0.49546 580.471 1.16375 579.796 1.99217 579.792L589.992 576.976C590.821 576.972 591.495 577.64 591.499 578.469C591.503 579.297 590.835 579.972 590.007 579.976L2.00679 582.792C1.17837 582.796 0.503534 582.128 0.499497 581.299Z"
      fill="#C5CEDE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 609.5L16.6378 609.5L16.6378 612.5L0.5 612.5L0.5 609.5ZM40.5028 609.5L70.2652 609.5L70.2652 612.5L40.5028 612.5L40.5028 609.5ZM93.9212 609.5L123.688 609.5L123.688 612.5L93.9212 612.5L93.9212 609.5ZM147.385 609.5L177.171 609.5L177.171 612.5L147.385 612.5L147.385 609.5ZM200.938 609.5L230.636 609.5L230.636 612.5L200.938 612.5L200.938 609.5ZM254.362 609.5L284.1 609.5L284.1 612.5L254.362 612.5L254.362 609.5ZM307.842 609.5L337.583 609.5L337.583 612.5L307.842 612.5L307.842 609.5ZM361.321 609.5L391.053 609.5L391.053 612.5L361.321 612.5L361.321 609.5ZM414.774 609.5L444.524 609.5L444.524 612.5L414.774 612.5L414.774 609.5ZM468.282 609.5L498.037 609.5L498.037 612.5L468.282 612.5L468.282 609.5ZM521.769 609.5L551.438 609.5L551.438 612.5L521.769 612.5L521.769 609.5ZM575.249 609.5L591.501 609.5L591.501 612.5L575.249 612.5L575.249 609.5Z"
      fill="#C5CEDE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M158 580.336C158 579.508 158.672 578.836 159.5 578.836H254C254.828 578.836 255.5 579.508 255.5 580.336C255.5 581.164 254.828 581.836 254 581.836H159.5C158.672 581.836 158 581.164 158 580.336Z"
      fill="url(#paint0_linear_3581_115187)"
    />
    <g filter="url(#filter0_f_3581_115187)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M318.998 88C180.928 88 69 200.771 69 339.881C69 446.39 134.613 537.458 227.336 574.294V464.206C227.336 463.371 227.666 462.569 228.252 461.979L333.261 356.267C335.23 354.285 338.595 355.69 338.595 358.495V402.318C338.595 405.796 341.393 408.615 344.845 408.615H450.546C509.285 408.615 539 387.745 539 344.614C539 300.786 507.903 277.829 450.546 277.829H344.845C341.393 277.829 338.595 280.648 338.595 284.126V330.413C338.595 333.217 335.23 334.622 333.261 332.64L228.252 226.929C227.666 226.338 227.336 225.537 227.336 224.701V200.646C227.336 197.168 230.134 194.348 233.586 194.348H456.765C482.936 194.348 506.752 196.843 528.044 201.689C483.359 133.209 406.419 88 318.998 88ZM235.552 407.199C233.565 409.189 230.184 407.743 230.224 404.921L231.97 282.927C232.01 280.149 235.342 278.781 237.298 280.74L295.099 338.629C297.557 341.091 297.557 345.099 295.099 347.561L235.552 407.199Z"
        fill="#DAE0EB"
      />
      <path
        d="M521.151 488.101C506.198 490.293 490.025 491.4 472.659 491.4H344.845C341.393 491.4 338.595 494.22 338.595 497.697V591C413.587 585.141 479.3 545.944 521.151 488.101Z"
        fill="#DAE0EB"
      />
    </g>
    <g filter="url(#filter1_dd_3581_115187)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M294.998 72C156.928 72 45 184.771 45 323.881C45 430.39 110.613 521.458 203.336 558.294V448.206C203.336 447.371 203.666 446.569 204.252 445.979L309.261 340.267C311.23 338.285 314.595 339.69 314.595 342.495V386.318C314.595 389.796 317.393 392.615 320.845 392.615H426.546C485.285 392.615 515 371.745 515 328.614C520 214 483.903 261.829 426.546 261.829H320.845C317.393 261.829 314.595 264.648 314.595 268.126V290.413C314.595 293.217 311.23 294.622 309.261 292.64L204.252 210.929C203.666 210.338 203.336 209.537 203.336 208.701V184.646C203.336 181.168 206.134 178.348 209.586 178.348H432.765C458.936 178.348 482.752 180.843 504.044 185.689C504.044 168.5 504 146.5 504 146.5C504 146.5 361.589 72 294.998 72ZM211.552 391.199C209.565 393.189 206.184 391.743 206.224 388.921L207.97 266.927C208.01 264.149 211.342 262.781 213.298 264.74L271.099 322.629C273.557 325.091 273.557 329.099 271.099 331.561L211.552 391.199Z"
        fill="#DAE0EB"
      />
      <path
        d="M497.151 472.101C497 459 497 444 497 433L320.845 475.4C317.393 475.4 314.595 478.22 314.595 481.697V575C389.587 569.141 455.3 529.944 497.151 472.101Z"
        fill="#DAE0EB"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M294.998 33C156.928 33 45 145.771 45 284.881C45 391.39 110.613 482.458 203.336 519.294V409.206C203.336 408.371 203.666 407.569 204.252 406.979L309.261 301.267C311.23 299.285 314.595 300.69 314.595 303.495V347.318C314.595 350.796 317.393 353.615 320.845 353.615H426.546C485.285 353.615 515 332.745 515 289.614C515 245.786 483.903 222.829 426.546 222.829H320.845C317.393 222.829 314.595 225.648 314.595 229.126V275.413C314.595 278.217 311.23 279.622 309.261 277.64L204.252 171.929C203.666 171.338 203.336 170.537 203.336 169.701V145.646C203.336 142.168 206.134 139.348 209.586 139.348H432.765C458.936 139.348 482.752 141.843 504.044 146.689C459.359 78.2095 382.419 33 294.998 33ZM211.552 352.199C209.565 354.189 206.184 352.743 206.224 349.921L207.97 227.927C208.01 225.149 211.342 223.781 213.298 225.74L271.099 283.629C273.557 286.091 273.557 290.099 271.099 292.561L211.552 352.199Z"
      fill="url(#paint1_linear_3581_115187)"
    />
    <path
      d="M497.151 433.101C482.198 435.293 466.025 436.4 448.659 436.4H320.845C317.393 436.4 314.595 439.22 314.595 442.697V536C389.587 530.141 455.3 490.944 497.151 433.101Z"
      fill="url(#paint2_linear_3581_115187)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M294.998 33C156.928 33 45 145.771 45 284.881C45 391.39 110.613 482.458 203.336 519.294V409.206C203.336 408.371 203.666 407.569 204.252 406.979L309.261 301.267C311.23 299.285 314.595 300.69 314.595 303.495V347.318C314.595 350.796 317.393 353.615 320.845 353.615H426.546C485.285 353.615 515 332.745 515 289.614C515 245.786 483.903 222.829 426.546 222.829H320.845C317.393 222.829 314.595 225.648 314.595 229.126V275.413C314.595 278.217 311.23 279.622 309.261 277.64L204.252 171.929C203.666 171.338 203.336 170.537 203.336 169.701V145.646C203.336 142.168 206.134 139.348 209.586 139.348H432.765C458.936 139.348 482.752 141.843 504.044 146.689C459.359 78.2095 382.419 33 294.998 33ZM211.552 352.199C209.565 354.189 206.184 352.743 206.224 349.921L207.97 227.927C208.01 225.149 211.342 223.781 213.298 225.74L271.099 283.629C273.557 286.091 273.557 290.099 271.099 292.561L211.552 352.199Z"
      fill="url(#paint3_linear_3581_115187)"
    />
    <path
      d="M497.151 433.101C482.198 435.293 466.025 436.4 448.659 436.4H320.845C317.393 436.4 314.595 439.22 314.595 442.697V536C389.587 530.141 455.3 490.944 497.151 433.101Z"
      fill="url(#paint4_linear_3581_115187)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M294.998 35C158.047 35 47 146.861 47 284.881C47 389.498 110.805 479.095 201.336 516.328V409.206C201.336 407.845 201.873 406.536 202.833 405.569L307.843 299.858C311.092 296.587 316.595 298.937 316.595 303.495V347.318C316.595 349.706 318.512 351.615 320.845 351.615H426.546C455.74 351.615 477.357 346.418 491.633 336.164C505.785 326.001 513 310.665 513 289.614C513 268.226 505.444 252.167 491.081 241.386C476.623 230.532 455.005 224.829 426.546 224.829H320.845C318.512 224.829 316.595 226.739 316.595 229.126V275.413C316.595 279.971 311.092 282.321 307.843 279.05L202.833 173.338C201.873 172.371 201.336 171.063 201.336 169.701V145.646C201.336 141.077 205.016 137.348 209.586 137.348H432.765C457.097 137.348 479.434 139.494 499.638 143.684C454.941 78.0434 379.955 35 294.998 35ZM502.456 144.285C457.55 77.1535 381.392 33 294.998 33C156.928 33 45 145.771 45 284.881C45 390.622 109.671 481.145 201.336 518.489C202.001 518.76 202.668 519.028 203.336 519.294V409.206C203.336 408.371 203.666 407.569 204.252 406.979L309.261 301.267C311.23 299.285 314.595 300.69 314.595 303.495V347.318C314.595 350.796 317.393 353.615 320.845 353.615H426.546C485.285 353.615 515 332.745 515 289.614C515 245.786 483.903 222.829 426.546 222.829H320.845C317.393 222.829 314.595 225.648 314.595 229.126V275.413C314.595 278.217 311.23 279.622 309.261 277.64L204.252 171.929C203.666 171.338 203.336 170.537 203.336 169.701V145.646C203.336 142.168 206.134 139.348 209.586 139.348H432.765C457.793 139.348 480.667 141.63 501.241 146.068C502.18 146.27 503.115 146.478 504.044 146.689C503.519 145.885 502.99 145.083 502.456 144.285ZM492.725 435.73C478.999 437.506 464.302 438.4 448.659 438.4H320.845C318.512 438.4 316.595 440.31 316.595 442.697V533.828C388.43 527.585 451.516 490.483 492.725 435.73ZM494.391 433.491C480.213 435.424 464.961 436.4 448.659 436.4H320.845C317.393 436.4 314.595 439.22 314.595 442.697V536C315.263 535.948 315.929 535.893 316.595 535.836C389.778 529.526 453.96 491.452 495.499 435.357C496.054 434.608 496.604 433.856 497.151 433.101C496.235 433.235 495.315 433.365 494.391 433.491ZM212.967 353.612C209.688 356.896 204.159 354.477 204.225 349.892L205.971 227.899C206.035 223.382 211.486 221.095 214.713 224.327L272.514 282.216C275.752 285.459 275.752 290.731 272.514 293.974L212.967 353.612ZM206.224 349.921C206.184 352.743 209.565 354.189 211.552 352.199L271.099 292.561C273.557 290.099 273.557 286.091 271.099 283.629L213.298 225.74C211.342 223.781 208.01 225.149 207.97 227.927L206.224 349.921Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_f_3581_115187"
        x="7"
        y="26"
        width="594"
        height="627"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="31" result="effect1_foregroundBlur_3581_115187" />
      </filter>
      <filter
        id="filter1_dd_3581_115187"
        x="9"
        y="53"
        width="544.461"
        height="577"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1" dy="18" />
        <feGaussianBlur stdDeviation="18.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.118021 0 0 0 0 0.161975 0 0 0 0 0.275 0 0 0 0.18 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3581_115187" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="3.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0916667 0 0 0 0 0.202833 0 0 0 0 0.333333 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_3581_115187" result="effect2_dropShadow_3581_115187" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3581_115187" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_3581_115187"
        x1="157.75"
        y1="580.836"
        x2="256.625"
        y2="580.836"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#C5CEDE" />
        <stop offset="0.49384" stopColor="#A8B2C4" />
        <stop offset="1" stopColor="#C5CEDE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3581_115187"
        x1="171.846"
        y1="78.5271"
        x2="302.009"
        y2="529.65"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F6F9FC" />
        <stop offset="1" stopColor="#F3F6F9" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3581_115187"
        x1="171.846"
        y1="78.5271"
        x2="302.009"
        y2="529.65"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F6F9FC" />
        <stop offset="1" stopColor="#F3F6F9" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3581_115187"
        x1="171.846"
        y1="78.5271"
        x2="302.009"
        y2="529.65"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F6F9FC" />
        <stop offset="1" stopColor="#F3F6F9" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3581_115187"
        x1="171.846"
        y1="78.5271"
        x2="302.009"
        y2="529.65"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F6F9FC" />
        <stop offset="1" stopColor="#F3F6F9" />
      </linearGradient>
    </defs>
  </svg>
)
